"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELAY = 100;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3B0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vcHRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBa0VhLFFBQUEsS0FBSyxHQUFHLEdBQUcsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-tooltip/build/src/options.js
// module id = 8aQN
// module chunks = 0